// client/src/routes/app/tenants/$tenantId/homes.tsx — SCR-TEN-002 tab „Locuințe" · D-2862.

import { createFileRoute } from '@tanstack/react-router';

import { HomesTab } from '@/features/tenants/HomesTab';

export const Route = createFileRoute('/app/tenants/$tenantId/homes')({
  component: HomesTabScreen,
});

function HomesTabScreen() {
  const { tenantId } = Route.useParams();
  return <HomesTab tenantId={tenantId} />;
}
